<template>
<div>
    <div>
        <div class="centered-div">
            <h3 class="register-text"><b>Register for {{ isGDPR ? "DataMapper GDPR" : "DataMapper" }}</b></h3>
        </div>
        <div v-if="success" class="success-text">
            <h3 class="success-h3">Success! We're sending you an invite.</h3>
            <div class="success-body-text">
            Just follow the link in the email
            and you will be organizing <br/> your documents in no time!
            </div>
        </div>
            <signup-error v-if="userExistsError"
            @hide="disableUserExistsError"/>
        <div v-if="!success">
            <div class="grid">
                <div class="centered-div">
                <form v-on:submit='createUser' class="register-form" @submit.prevent="noRefresh">
                    <div class="email-label-text">
                    Email
                    </div>
                    <input type="email" placeholder="your@email.com" v-model="email"/>
                    <div class="validation-block">
                        <p v-if="!$v.email.required && submitted">The email field is required.</p>
                        <p v-if="!$v.email.email && submitted">The email must be valid.</p>
                    </div>
                    <br/>
                    <div class="invite-text">
                    You will receive an invite to {{ isGDPR ? "DataMapper GDPR " : "DataMapper" }} after registering
                    </div>
                </form>
                <button class="register-button"
                        @click="createUser">continue</button>
                <div class="terms-text">
                    By signing up I agree to DataMapper's
                    <a href="https://bysafeonline.com/connectid-datamapper-terms-of-use/" target="_blank">Terms of Use</a>
                     and
                    <a href="https://bysafeonline.com/connectid-datamapper-resources" target="_blank">Privacy Policy</a>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import SignupError from './SignupError'

export default {
    components: { SignupError },
    data () {
        return {
            email: '',
            userExistsError: false,
            errorMessage: "",
            success: false,
            submitted: false
        }
    },
    computed: {
        ...mapState(['pageInfo']),
        isGDPR () {
            return !this.$route.path.endsWith('register-cs')
        }
    },

    methods: {
        noRefresh () {},
        disableUserExistsError() { this.userExistsError = false },
        createUser: function () {
            this.submitted = true
            if(!this.$v.email.required || !this.$v.email.email) return
            this.$store.commit('updatePageInfo', {
                ...this.pageInfo,
                loading: true
            })
            const self = this
            this.$Api.admin.register(
                this.email,
                this.isGDPR
            ).then(
                () => { self.success = true }
            ).catch(
                error => {
                    if (error.message === 'userExists') self.userExistsError = true
                    else {
                        return self.$store.dispatch('error', {
                            message: 'Something unexpected happen. ' +
                            'Please try again later. Reason: ' + error.message
                        })
                    }
                }
            ).finally(() => { self.$store.commit('updatePageInfo', {...self.pageInfo, loading: false})
            })
        }
    },
    validations: {
        email: {
            required, email
        }
    }
}

</script>

<style lang="scss">
@import "~@/assets/scss/index.scss";

    .centered-div {
        width: 60%;
        margin: 0 auto;
    }

    .form form.register-form {
        width: 100%;
        min-height: 0;
        margin-bottom: 20px;

        input {
            width: 100%;
        }

        .validation-block {
            margin-top: 4px;
            height: 10px;
        }

        p {
            font-size: 13px;
            color: red;
        }
    }

    div.email-label-text {
        font-size: 16px;
    }

    div.invite-text {
        font-size: 11px;
    }

     div.terms-text {
            font-size: 10px;
    }

    .form button.register-button {
        /*padding: 0 0 0 0;*/
        width: 100%;
        padding: 15px 40px;
        margin-bottom: 20px;
    }

    .register-text {
        padding-top: 30px;
        text-align: center;
    }

    section.form .form-container {
       width: 500px;
    }

    .success-body-text {
        margin-top: 10px;
    }
    .success-text {
        .success-h3 {
            font-size: 20px;
        }
        margin-top: 50px;
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// apps/account/Register.vue